module.exports = __webpack_public_path__ + "static/img/train-img.5dc8a287.png";